import React from "react";

function useLoader() {
  const [loading, setLoading] = React.useState(false);
  const startLoading = () => {
    setLoading(true);
  };
  const stopLoading = () => {
    setLoading(false);
  };

  return { loading, startLoading, stopLoading };
}

export default useLoader;
